export const Themes = {
  dark: {
    primary: '#2196f3',
    primary_flat: '#2196f3',
    secondary: '#2196f320',
    secondary_flat: '#2196f350',
    background_body: '#131722',
    background_nav: '#1e222d',
    background_input: '#ffffff30',
    background: '#1e222d',
    color_text: '#ffffff',
    border_color: '#ffffff20',
    light: '220%',
    hr_color: '#ffffff90',
  },
  light: {
    primary: '#2196f3',
    primary_flat: '#00000090',
    secondary: '#2196f320',
    secondary_flat: '#2196f350',
    background_body: '#f7f7f7',
    background_nav: '#fff',
    background_input: '#00000010',
    background: '#fff',
    color_text: '#00000095',
    border_color: '#00000020',
    light: '100%',
    hr_color: '#00000070',
  },
};
